import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { HtmlViewer } from "../../controls/html/htmlViewer";
import { InfoFeedClient } from "../../helpers/client";
import { BreadcrumbsBar } from "../breadcrumbs/breadcrumbsBar";
import { PrivacyPolicyRoute } from "../../routes/allRoutes";

export function PrivacyPolicy() {
    const infoFeedsClient = new InfoFeedClient();
    const [privacyPolicy, setPrivacyPolicy] = useState<string>();

    useEffect(() => {
        getPrivacyPolicy();
    }, [])

    const getPrivacyPolicy = () => {
        infoFeedsClient.getCompanyPrivacyPolicy().then(response => {
            setPrivacyPolicy(response);
        }).catch(err => console.log(err));
    }

    return (
        <Grid container direction="column" alignItems="center">
            <BreadcrumbsBar paths={[{ path: PrivacyPolicyRoute }]} />
            <Grid sx={{
                maxWidth: "1000px",
                width: "100%",
                backgroundColor: "white",
                borderRadius: "15px"
            }}>
                <HtmlViewer content={privacyPolicy} />
            </Grid>
        </Grid>
    );
}